// export const API_URL = process.env.REACT_APP_API_URL;
// export const API_URL = 'http://localhost:8000/api';
export const API_URL = 'https://api.koscatrecycler.com/api';